const useVehicleMethods = () =>{
    const getSimilarVehicles = async (stockNumber: number) =>{
        const response = await fetch(
            `/api/vehicles/similar?stockNumber=${Number(stockNumber)}`
        ).then((response) => response.json());
        return response?.list || [];
    };

    const getViewsByVehicle = async (stockNumber: number, onlyGet: boolean) =>{
        const response = await fetch(
            `/api/vehicles/views?stockNumber=${Number(stockNumber)}&onlyGet=${onlyGet}`
        ).then((response) => response.json());
        return response?.list || 0;
    };

    const getWebsiteVehicles = async (params: any) =>{
        const response = await fetch(`/api/vehicles/srplist`,
            { 
                method: 'POST',
                body: JSON.stringify(params),
            }
        ).then((response) => response.json());
        return response?.list || [];
    };

    const getVehicleFilters = async () =>{
        const response = await fetch('/api/vehicles/filters')
            .then((response) => response.json());
        return response?.list || [];
    };

    return {getSimilarVehicles, getViewsByVehicle, getWebsiteVehicles, getVehicleFilters};
};

export default useVehicleMethods;